"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }

function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }

function _classPrivateFieldGet(receiver, privateMap) { var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "get"); return _classApplyDescriptorGet(receiver, descriptor); }

function _classExtractFieldDescriptor(receiver, privateMap, action) { if (!privateMap.has(receiver)) { throw new TypeError("attempted to " + action + " private field on non-instance"); } return privateMap.get(receiver); }

function _classApplyDescriptorGet(receiver, descriptor) { if (descriptor.get) { return descriptor.get.call(receiver); } return descriptor.value; }

var _event_handlers = /*#__PURE__*/new WeakMap();

class EventHandler {
  constructor() {
    _classPrivateFieldInitSpec(this, _event_handlers, {
      writable: true,
      value: []
    });
  }

  on(event, fn) {
    _classPrivateFieldGet(this, _event_handlers)[event] = fn;
  }

  trigger(event, ...args) {
    if (_classPrivateFieldGet(this, _event_handlers)[event]) {
      return _classPrivateFieldGet(this, _event_handlers)[event](this, ...args);
    }

    return true;
  }

}

exports.default = EventHandler;